<template>
    <div id="cb-templates" :class="{ akinon, pageMode }">
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="side-menubar-wrapper" v-if="showSideBar">
                <SideMenuBar selected-page="templates" selected-sub-page="templates" />
            </div>
            <div class="_content">
                <div class="search-wrapper" v-if="showSearch">
                    <div class="input-container" tabindex="0">
                        <input :placeholder="$t('message.search')" v-model="search" />
                        <md-icon>search</md-icon>
                    </div>
                </div>
                <div class="section-templates">
                    <div class="section-templates-header" v-if="showSideBar">
                        <div text-type="h2" text-weight="semi-bold" class="section-templates-header-text">
                            {{ $t("chatbotv2.allTemplates") }}
                        </div>
                    </div>
                    <div class="template-list">
                        <div
                            class="template-list-item"
                            v-for="(item, i) of getFilteredTemplates()"
                            :key="item.slug"
                            @click="selectedTemplate = item"
                        >
                            <div class="template-list-item-inner-wrapper">
                                <div class="block-template">
                                    <div class="d-flex">
                                        <div>
                                            <div class="icon" v-if="akinon || i !== 0">
                                                <img :src="item.imageUrl" :alt="'Create ' + item.name" />
                                            </div>
                                            <div class="title">{{ item.name }}</div>
                                            <div class="shortDescription">
                                                {{ item.shortDescription }}
                                            </div>
                                        </div>
                                        <img
                                            class="image"
                                            src="/static/img/chatbot/customer-satisfaction-bot.png"
                                            v-if="!akinon && i === 0"
                                        />
                                    </div>
                                    <div>
                                        <a-button
                                            type="primary"
                                            :ghost="i !== 0"
                                            @click="selectedTemplate = item"
                                            :disabled="!item.enabled"
                                        >
                                            {{ item.enabled ? $t("chatbotv2.importBot") : $t("chatbotv2.comingSoon") }}
                                        </a-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a-modal
            centered
            :visible="!!selectedTemplate"
            :footer="null"
            :closable="true"
            @cancel="selectedTemplate = null"
            v-if="selectedTemplate"
            class="template-modal"
        >
            <div class="modal-import-template">
                <div class="description">
                    <div class="top">
                        <img :src="selectedTemplate.imageUrl" :alt="selectedTemplate.name" class="image" />
                        <div class="header">
                            <div class="title">
                                {{ selectedTemplate.name }}
                            </div>
                            <a-button
                                type="primary"
                                ghost
                                :disbled="importing"
                                :loading="importing"
                                @click="() => createStory(selectedTemplate.slug)"
                                :disabled="!selectedTemplate.enabled"
                            >
                                {{ importing ? $t("chatbotv2.importing") : $t("chatbotv2.importBot") }}
                            </a-button>
                        </div>
                    </div>
                    <div class="tpl-markdown description-content">
                        <p>
                            {{ selectedTemplate.description.split("\n")[0] }}
                        </p>
                        <p>
                            <strong>{{ $t("chatbotv2.keyFeatures") }}:</strong>
                        </p>
                        <ul>
                            <li
                                v-for="(keyFeature, index) of $_.drop(selectedTemplate.description.split('\n'), 3)"
                                :key="index"
                            >
                                {{ keyFeature.replace("*", "").trim() }}
                            </li>
                        </ul>
                    </div>
                    <!---->
                </div>
                <div class="details">
                    <div class="section">
                        <div class="label">{{ $t("chatbotv2.lastUpdate") }}</div>
                        <div class="data">{{ timeHumanize(selectedTemplate.updatedAt) }}</div>
                    </div>
                    <div class="section">
                        <div class="label">{{ $t("chatbotv2.categories") }}</div>
                        <div class="data" style="flex-direction: column; align-items: flex-start">
                            {{ selectedTemplate.categories.join(", ") }}
                        </div>
                    </div>
                    <div class="section">
                        <div v-if="$i18n.locale === 'en' || $i18n.locale === 'ru'" class="label">
                            {{ $t("chatbotv2.worksWith") }}
                        </div>
                        <div class="data" style="flex-direction: column; align-items: flex-start">
                            <div class="display-integrations">
                                <img class="icon supsis" src="/static/img/supsis-logo3.png" />

                                <WhatsappIcon :special-background-mode="true" :color="'#28AC01'" class="templates-whatsapp-icon" />
                                <TelegramIcon />
                            </div>
                        </div>
                        <div v-if="$i18n.locale === 'tr'" class="label">{{ $t("chatbotv2.worksWith") }}</div>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import SideMenuBar from "../../SideMenuBar";
import log2 from "../../../../../utils/log2";
import { mapActions, mapMutations } from "vuex";
import CHATBOT_TEMPLATES from "./chatbot-templates";
import moment from "moment";
import _ from "lodash";
import CONFIG from "../../../../../config/config";
import WhatsappIcon from "../integrations/svg/WhatsappIcon.vue";
import TelegramIcon from "../integrations/svg/TelegramIcon.vue";
import CHATBOT_AI_TEMPLATES from "./chatbot-ai-templates";

const log = log2("Templates");
export default {
    name: "Templates",
    components: { WhatsappIcon, TelegramIcon, SideMenuBar },
    props: {
        showSideBar: {
            type: Boolean,
            default: true,
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
        enabledSlugs: {
            type: Array,
            default: () => [],
        },
        pageMode: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            search: null,
            items: CHATBOT_TEMPLATES,
            selectedTemplate: null,
            importing: false,
            akinon: CONFIG.AKINON.enabledReal,
        };
    },
    methods: {
        ...mapMutations({
            SET_LARGE_HEADER: "app/SET_LARGE_HEADER",
        }),
        ...mapActions({
            createStoryFromTemplate: "CB/createStoryFromTemplate",
        }),
        open(item) {
            if (item.enabled) {
                this.selectedTemplate = item;
            }
        },
        timeHumanize(date) {
            return moment(date).calendar();
        },
        createStory(slug) {
            this.importing = true;
            this.createStoryFromTemplate(slug)
                .then((result) => {
                    if (!!result) {
                        this.selectedTemplate = null;
                        this.$message.success({
                            content: `Story imported successfully`,
                            duration: 2,
                        });
                        setTimeout(() => {
                            this.$router.push(`/chatbot/story/${result.story._id}/${result.board.version}`);
                        }, 500);
                    } else {
                        this.$message.error({
                            content: `Story import failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error({
                        content: `Story import failed`,
                        duration: 2,
                    });
                })
                .finally(() => {
                    this.importing = false;
                });
        },
        getFilteredTemplates() {
            const q = (this.search || "").trim().toLowerCase();
            return this.items
                .filter((x) => x.visible)
                .filter((item) => {
                    if (_.isEmpty(this.enabledSlugs)) {
                        return _.isEmpty(q) ? true : item.name.trim().toLowerCase().includes(q);
                    } else {
                        return (
                            this.enabledSlugs.includes(item.slug) &&
                            (_.isEmpty(q) ? true : item.name.trim().toLowerCase().includes(q))
                        );
                    }
                });
        },
    },

    mounted() {
        log("this.$route.path", this.$route.path);
        this.SET_LARGE_HEADER(false);
    },
    beforeDestroy() {
        this.SET_LARGE_HEADER(true);
    },
};
</script>

<style lang="scss">
#cb-templates {
    height: auto;

    display: flex;

    &.pageMode {
        min-height: 100vh;

        ._content {
            min-height: 100vh;
        }
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    ._content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;

        .search-wrapper {
            width: 100%;
            display: flex;
            justify-content: flex-end;

            .input-container {
                width: 300px;
                display: flex;
                justify-content: space-between;
                position: relative;

                input {
                    width: 100%;
                    outline: none;
                    height: 40px;
                    color: #22272d;
                    border: 1px solid #c6cdd4;
                    border-radius: 6px;
                    padding: 9px 35px 9px 17px;
                    font-size: 14px;
                    line-height: 20px;

                    &::placeholder {
                        color: #c6cdd4;
                    }

                    &::-ms-input-placeholder {
                        color: #c6cdd4;
                    }

                    &:focus {
                        border-color: #006cff;

                        & ~ i {
                            color: #006cff;
                        }
                    }
                }

                i {
                    position: absolute;
                    right: 5px;
                    top: 7px;
                    color: #c6cdd4;
                }
            }
        }
    }

    .section-templates {
        margin-bottom: 30px;
        width: 100%;

        .section-templates-header {
            align-items: center;
            display: flex;
            justify-content: space-between;
            margin-bottom: 16px;
            width: 100%;

            .section-templates-header-text {
                align-items: center;
                display: flex;
                font-weight: 600;
                font-size: 24px;
                line-height: 31px;
            }
        }

        .template-list {
            display: flex;
            align-items: stretch;
            flex-wrap: wrap;
            margin: -10px;

            .template-list-item {
                width: 300px;
                min-width: 225px;
                padding: 10px;
                display: flex;

                .template-list-item-inner-wrapper {
                    cursor: pointer;
                    border: 1px solid #dbe1e8;
                    box-shadow: 0 1px 15px rgb(0 0 0 / 4%);
                    border-radius: 4px;
                    height: 100%;
                    min-height: 180px;
                    overflow: hidden;
                    width: 100%;

                    &:hover {
                        border-color: #008aff;
                    }

                    .block-template {
                        border-color: #dbe1e8;
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: space-between;
                        min-height: 260px;
                        padding: 30px 20px;
                        position: relative;
                        width: 100%;

                        .icon {
                            height: 45px;
                            width: 45px;
                        }

                        .title {
                            -webkit-line-clamp: 2;
                            max-height: 46px;
                            word-wrap: break-word;
                            display: -webkit-box;
                            line-height: 23px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin-bottom: 5px;
                            margin-top: 10px;
                            font-weight: 600;
                            font-size: 18px;
                        }

                        .shortDescription {
                            -webkit-box-orient: vertical;
                            word-wrap: break-word;
                            display: -webkit-box;
                            line-height: 20px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -webkit-line-clamp: 3;
                            max-height: 60px;
                            color: #516173;
                            font-size: 16px;
                        }
                    }
                }
            }

            .template-list-item:first-child {
                width: 600px;

                .template-list-item-inner-wrapper {
                    background-color: #f2f2f2;
                    border-color: #f2f2f2;
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: center;
                    min-height: 295px;
                    padding: 0 60px;
                    position: relative;
                    width: 100%;

                    &:hover {
                        border-color: #008aff;
                    }

                    .block-template {
                        padding: 30px 1px;
                    }

                    .image {
                        background-position: 100%;
                        background-repeat: no-repeat;
                        background-size: auto 100%;
                        width: 200px;
                        height: 200px;
                        margin-left: 30px;
                        user-select: none;
                    }
                }
            }
        }
    }

    &.akinon {
        .template-list {
            //.template-list-item:first-child {
            //    width: 300px !important;
            //}
            .template-list-item {
                width: 33% !important;
            }
        }

        div.icon {
            display: flex !important;
            justify-content: flex-end !important;
            width: 100% !important;
        }
    }

    &.ai {
        .template-list {
            .template-list-item {
                width: 300px !important;
            }
        }
    }
}

.modal-import-template {
    background: #fff;
    border-radius: 6px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-height: inherit;
    padding: 60px 20px 30px;
    position: relative;

    .description {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        height: inherit;
        padding-bottom: 20px;
        padding-right: 20px;

        .top {
            display: flex;
            flex-direction: row;

            .image {
                border-radius: 4px;
                height: 70px;
                width: 70px;
            }

            .header {
                margin-left: 15px;

                .title {
                    margin-bottom: 5px;
                    color: #22272d;
                    font-weight: 600;
                    font-size: 22px;
                    line-height: 28px;
                }
            }
        }

        .description-content {
            color: #516173;
            flex-grow: 1;
            font-size: 15px;
            margin-top: 25px;
            line-height: 1.6;

            p,
            ul {
                margin: 15px 0;
            }

            p:first-child {
                margin-top: 0 !important;
            }

            ul:last-child {
                margin-bottom: 0 !important;
            }

            ul {
                li {
                    margin: 5px 0;
                }
            }
        }
    }

    .details {
        border-left: 1px solid #dbe1e8;
        flex-shrink: 0;
        height: inherit;
        padding-left: 20px;
        width: 200px;

        .templates-whatsapp-icon{
            width: 17px !important;
            height: 17px !important;
        }
        .display-integrations {
            display: flex;
            align-items: center;
            gap: 5px;

            svg {
                width: 20px;
                height: 20px;
            }
        }

        .icon {
            width: 26px;
            height: 26px;

            &.wp {
                width: 20px;
                height: 20px;
            }
        }

        .section {
            margin-bottom: 15px;

            .label {
                color: #516173;
                font-weight: 600;
                margin-bottom: 5px;
            }

            .data {
                align-items: center;
                color: #22272d;
                display: flex;
                font-weight: 600;
                text-transform: capitalize;
            }
        }
    }
}

.template-modal {
    .ant-modal {
        width: 700px !important;
    }
}
</style>
